var render = function render(){var _vm=this,_c=_vm._self._c;return _c('block-u-i',{directives:[{name:"show",rawName:"v-show",value:(_vm.blockPage),expression:"blockPage"}],attrs:{"message":_vm.msg}},[_c('i',{staticClass:"fa fa-cog fa-spin fa-3x fa-fw"})])
}
var staticRenderFns = []

export { render, staticRenderFns }